import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import FoundReportDetailsHeader from "./FoundReportDetailsHeader";
import { ReportsWrapper } from "./styles";
import FoundReportDetailsBody from "./FoundReportDetailsBody";
import FoundReportDetailsFooter from "./FoundReportDetailsFooter";
import { useAppDispatch, useAppSelector } from "../../utils/hooks/redux";
import { getFoundReportAsyncThunk } from "../../redux/features/foundReport/foundReportAsyncThunk";
import { Alert } from "antd";
import { useQueryParams } from "../../utils/hooks/useQueryParams";

const FoundReportDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const { data, status, error, versionData } = useAppSelector((state) => state.foundReport);
  const { getParam } = useQueryParams();

  useEffect(() => {
    if (id) {
      const withDeleted = getParam("withDeleted");
      dispatch(getFoundReportAsyncThunk({ id, withDeleted: withDeleted === "true" }));
    }
  }, [dispatch, id]);

  return (
    <>
      {
        status === "failed" ? <Alert type="error" showIcon message={error} />
          :
          <>
            <FoundReportDetailsHeader isLoading={status === 'loading'} report={data} versionData={versionData} />
            <ReportsWrapper>
              <FoundReportDetailsBody />
            </ReportsWrapper>
            {/* <FoundReportDetailsFooter status="" isLoading={status === 'loading'} report={data} versionData={versionData} /> */}
          </>
      }
    </>
  );
};

export default FoundReportDetails;
